import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '@loczi/auth'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('./views/LoginView.vue'), meta: { public: true } },
    { path: '/select-account', name: 'select-account', component: () => import('./views/SelectAccountView.vue'), meta: { public: true } },
    // Autenticado sem conta nenhuma (ex.: cadastro via Google) — a única
    // saída é contratar no site; fora do shell (não há conta p/ contexto).
    { path: '/sem-servico', name: 'no-service', component: () => import('./views/NoServiceView.vue') },
    {
      path: '/',
      component: () => import('./layouts/MobileShell.vue'),
      children: [
        { path: '', redirect: '/tags' },
        { path: 'tags', name: 'tags', component: () => import('./views/TagsView.vue') },
        { path: 'tags/:id', name: 'tag-detail', component: () => import('./views/TagDetailView.vue') },
        { path: 'map', name: 'map', component: () => import('./views/MapView.vue') },
        { path: 'alerts', name: 'alerts', component: () => import('./views/AlertsView.vue') },
        { path: 'account', name: 'account', component: () => import('./views/AccountView.vue') },
        { path: 'activate', name: 'activate', component: () => import('./views/ActivateView.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/tags' },
  ],
})

router.beforeEach(async (to) => {
  const session = useSessionStore()
  if (!session.ready) await session.bootstrap()

  if (to.meta.public) {
    if (session.isAuthenticated && to.name === 'login') return { name: 'tags' }
    if (session.isAuthenticated && to.name === 'select-account' && session.accounts.length === 0) {
      return { name: 'no-service' }
    }
    return true
  }

  if (!session.isAuthenticated) return { name: 'login' }
  // Sem conta nenhuma não há painel — leva à tela de contratação.
  if (session.accounts.length === 0) {
    return to.name === 'no-service' ? true : { name: 'no-service' }
  }
  return true
})
